// components/orders/DeliveryCodeModal.jsx
import React, { useState } from 'react';
import { HiLockClosed } from 'react-icons/hi';
import FormError from '../../components/feedback/FormError';
import OTPInput from "otp-input-react";
import toast from 'react-hot-toast';

function DeliveryCodeModal({ onConfirm, updateError, isLoading = false, payment }) {
    const [code, setCode] = useState(0);
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (payment?.delivery_status === 'Delivered') {
            toast.error("Item already delivered")
            return
        }
        if (!code.trim()) {
            setError('Please enter the delivery confirmation code.');
            return;
        }
        setError('');
        onConfirm(code);
    };

    return (
        <>
            <label htmlFor="delivery-code-modal" id="delivery-code-open-btn" className="hidden">
                Open Delivery Code Modal
            </label>
            <input type="checkbox" id="delivery-code-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box w-11/12 max-w-md">
                    <label
                        onClick={() => setCode(0)}
                        id='delivery-close-open-btn'
                        htmlFor="delivery-code-modal"
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                    >
                        ✕
                    </label>

                    <div className="text-center mb-4">
                        <HiLockClosed className="h-12 w-12 mx-auto text-primary mb-3" />
                        <h3 className="font-bold text-lg">Confirm Delivery</h3>
                        <p className="text-gray-600 mt-2">
                            Please ask the customer for their <strong>delivery code</strong> and enter it below to complete the order.
                        </p>
                    </div>

                    <form onSubmit={handleSubmit}>
                        {updateError && (<FormError error={updateError} />)}
                        <div className="form-control mb-3">
                            <label className="label">
                                <span className="label-text">Delivery Code</span>
                            </label>
                            <OTPInput
                                value={code}
                                inputClassName="border rounded-lg text-black"
                                inputStyles={{
                                    width: "42px",
                                    height: "42px",
                                }}
                                onChange={setCode}
                                autoFocus={true}
                                OTPLength={6}
                                otpType="number" />
                        </div>

                        {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

                        <div className="modal-action">
                            <button
                                type="submit"
                                className="btn btn-primary w-full"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <span className="loading loading-spinner loading-sm"></span>
                                ) : (
                                    'Confirm Delivery'
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default DeliveryCodeModal;